<section class="sh-dialog__content">
  @if (config.data.errorMessage) {
    <div class="sh-notification--error">
      <figure class="sh-notification__icon">
        <svg sh-icon [name]="'delete'"></svg>
      </figure>
      <span>
        <sh-html-parser [message]="config.data.errorMessage"></sh-html-parser>
      </span>
    </div>
  }
  @if (config.data.warningMessage) {
    <div class="sh-notification--warning">
      <figure class="sh-notification__icon">
        <svg sh-icon [name]="'exclamation-circle'"></svg>
      </figure>
      <span>
        <sh-html-parser [message]="config.data.warningMessage"></sh-html-parser>
      </span>
    </div>
  }
  @if (config.data.infoMessage) {
    <div class="sh-notification--update">
      <figure class="sh-notification__icon">
        <svg sh-icon [name]="'info'"></svg>
      </figure>
      <span>
        <sh-html-parser [message]="config.data.infoMessage"></sh-html-parser>
      </span>
    </div>
  }
  @if (config.data.message) {
    <p>
      <sh-html-parser [message]="config.data.message"></sh-html-parser>
    </p>
  }
  <sh-form-text-input [label]="config.data.inputLabel" [control]="inputControl"></sh-form-text-input>
</section>
<footer class="sh-dialog__footer">
  <div class="sh-action-group -sh-align-end">
    @if (config.data.confirm) {
      <button type="button" class="sh-button sh-action-group__item" [disabled]="inputControl.invalid" (click)="confirm()">
        {{ config.data.confirm }}
      </button>
    }
    @if (config.data.no) {
      <button type="button" class="sh-button--secondary sh-action-group__item" (click)="no()">{{ config.data.no }}</button>
    }
  </div>
</footer>
